import styled from 'styled-components';
import { Button } from '../../../common/components/Button/Button';
import { ButtonVariants } from '../../../common/components/Button/DeprecatedButtonVariants';
import { Link } from '../../../common/components/Link';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';

export const View = styled.div`
  ${FONT_STACK};
  padding: 40px;
  text-align: center;

  ${onMobile} {
    padding: 20px;
  }
`;

export const Heading = styled.div`
  color: ${ThemeColours.black};
  font-size: 24px;
  margin-bottom: 12px;

  ${onMobile} {
    padding-top: 32px;
  }
`;

export const Message = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 18px;
  margin-bottom: 32px;
`;

export const Centered = styled.div`
  margin: auto;
`;

export const StyledButton = styled(Button)`
  font-size: 16px;
  font-weight: ${FontWeight.REGULAR};
  margin: 0 auto 16px;
`;

export const SeeDentistButton = styled(StyledButton).attrs({
  variant: ButtonVariants.transparentTeal,
})`
  border: 2px solid ${ThemeColours.mono200};
`;

export const CancelButton = styled(StyledButton).attrs({
  variant: ButtonVariants.transparentTeal,
})`
  margin: 0 auto;
`;

export const StyledLink = styled(Link)`
  ${FONT_STACK};
  color: ${ThemeColours.primary};
  font-size: 18px;
  text-decoration: none;
`;

export const ImageContainer = styled.div`
  margin-bottom: 36px;
`;
